



























































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import SwLoginLeftLoginPanel from './sw-login-left-login-panel.vue';
import SwLoginEagle from './sw-login-eagle.vue';
import { LoginModel } from '../interfaces/sw-login-interfaces';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { State } from 'vuex-class';
import { SwBlockingProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-blocking-progress';
import { RootStoreState } from '@/store';

const cssPrefix = 'sw-login';
@Component({
  components: {
    SwLoginLeftLoginPanel,
    SwLoginEagle,
    SwMessageContainer,
    SwBlockingProgress,
  },
})
export default class SwLogin extends SwExtendedVue {
  cssPrefix = cssPrefix;
  skipAnimationEnabled = false;
  skipAnimation () {
    this.skipAnimationEnabled = true;
  }
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;

  @Prop({ required: true })
  value: LoginModel;

  @Prop({ default: false })
  flatEdge: boolean;
  links = [
    {
      title: '',
      text: '',
      color: '#48B5C3',
      href: '/m/login/login-view',
    },
    {
      title: '',
      text: '',
      color: '#C68DBA',
      href: '/m/login/login-view',
    },
    {
      title: '',
      text: '',
      color: '#BADB77',
      href: '/m/login/login-view',
    },
  ];

  passLogin(event: any) {
    this.$emit('loginCheck', event);
  }

}
